"use client";

import Link from "next/link";
import { useState } from "react";
import { MapView } from "@/components/map/MapView";
import type { MapMarker, MapTrack } from "@/components/map/types";
import { toggleStop, usePlan } from "./store";
import "./route.css";

type Props = { label: string; markers: MapMarker[]; tracks: MapTrack[]; focus?: string; maxStops: number };

/** Inselkarte mit „Zur Route hinzufügen“ im Pin-Popup; geplant wird auf /routen. */
export function PlanMap({ label, markers, tracks, focus, maxStops }: Props) {
  const plan = usePlan();
  const [msg, setMsg] = useState("");
  const toggle = (id: number) => {
    const name = markers.find((m) => m.planId === id)?.title ?? "Ort";
    const had = !!plan?.stops.some((s) => s.id === id);
    if (!toggleStop(id, maxStops)) return setMsg(`Die Route hat schon ${maxStops} Stopps.`);
    setMsg(had ? `${name} aus der Route entfernt.` : `${name} zur Route hinzugefügt.`);
  };
  return (
    <>
      <MapView mode="full" label={label} markers={markers} tracks={tracks} focus={focus}
        plan={{ start: plan?.start ?? null, stops: plan?.stops.map((s) => s.id) ?? [], lines: [] }} onPlanToggle={toggle} />
      <div role="status" className="sr-only">{msg}</div>
      {msg && (
        <p className="rp-toast">
          <span>{msg}</span>
          <Link href="/routen">Zum Routenplaner</Link>
          <button type="button" aria-label="Hinweis schließen" onClick={() => setMsg("")}>×</button>
        </p>
      )}
    </>
  );
}
